import { render } from "./GProductosModal.vue?vue&type=template&id=461d5ddf"
import script from "./GProductosModal.vue?vue&type=script&lang=js"
export * from "./GProductosModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__